import { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export function svgIcon(theme: Theme) {
  return {
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          fill: 'default'
        },
        fontSizeLarge: {
          width: 32,
          height: 32,
          fontSize: theme.typography.fontSize,
        },
      },
    },
  };
}
